import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'reputation',
  type: 'node--online_reputation',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    url: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    comentario: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'comentario',
    },
  },
  relationships: {
    document: {
      type: 'node--document',
      required: false,
      isArray: false,
      name: 'document',
    },
    file: {
      type: 'file--file',
      required: false,
      isArray: false,
      name: 'file',
    },
  },
};

export const ReputationService = createService(base, configuration, API_CONFIG.API);
export const ReputationModule = createModule(ReputationService, true);



// WEBPACK FOOTER //
// ./src/models/reputation.js